module.exports = __webpack_public_path__ + "static/media/danxuanfuxuan.dab72da5.png";


//////////////////
// WEBPACK FOOTER
// ./src/vehicleInquiry/change/images/danxuanfuxuan.png
// module id = 1605
// module chunks = 0